/**
 * @prettier
 * @flow
 */
import Button from '@material-ui/core/Button'; // Added import for Button
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Router } from '@reach/router';
import React from 'react';
import openlinealogo from 'src/images/openlinealogo.png';
import { actions } from 'src/reducers';
import { CreatePaymentLinkPage } from 'src/scenes/CreatePaymentLinkPage';
import { NotFoundPage } from 'src/scenes/NotFoundPage';
import { PaymentLinkPage } from 'src/scenes/PaymentLinkPage';
import { PaymentLinksPage } from 'src/scenes/PaymentLinksPage';
import { SignInPage } from 'src/scenes/SignInPage';
import { VersionPage } from 'src/scenes/VersionPage';
import { useAction } from 'src/utils/react/useAction';
import { useSelector } from 'src/utils/react/useSelector';
import { translate } from 'src/utils/translate/translate';

export function App() {
    const classes = useStyles();
    const signedIn = useSelector(state => state.app.signedIn);
    const appSnackBar = useSelector(state => state.app.appSnackBar);
    const closeAppSnackBar = useAction(actions.closeAppSnackBar);
    const signOutUser = useAction(actions.signOutUser);

    return (
        <main className={classes.container}>
            <Grid container direction='row' justifyContent='space-between' alignItems='center' className={classes.headerContainer}>
                <Grid item>
                    <img src={openlinealogo} alt='Operaciones en Línea' height={40} />
                </Grid>
                {signedIn && (
                    <Grid item>
                        <Button color='secondary' onClick={signOutUser}>
                            {translate('Sign Out')}
                        </Button>
                    </Grid>
                )}
            </Grid>
            <Router>
                <VersionPage path='/version' />
                {!signedIn ? (
                    <SignInPage path='/*' />
                ) : (
                    <>
                        <PaymentLinksPage path='/' />
                        <PaymentLinkPage path='/link/:paymentLinkId' />
                        <CreatePaymentLinkPage path='/link/new' />
                        <NotFoundPage default />
                    </>
                )}
            </Router>
            <Grid container direction='row' justifyContent='center' alignItems='center' className={classes.footerContainer}>
                <Typography variant='caption' component='a' href={'http://openlinea.mx'} className={classes.link}>
                    Powered by <img src={openlinealogo} style={{ verticalAlign: 'bottom', marginBottom: 0.75 }} alt='Operaciones en Línea' height={18} />
                </Typography>
                <Typography variant='caption' component='a' href={'http://openlinea.mx/terms'} className={classes.link}>
                    {translate('Terms and Conditions')}
                </Typography>
                <Typography variant='caption' component='a' href={'http://openlinea.mx/privacy'} className={classes.link}>
                    {translate('Privacy')}
                </Typography>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={appSnackBar.open}
                message={appSnackBar.message}
                autoHideDuration={appSnackBar.autoHideDuration}
                onClose={() => {
                    closeAppSnackBar();
                }}
            />
        </main>
    );
}

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    container: {
        width: 'auto',
        margin: theme.spacing(2),
        [theme.breakpoints.up(1024 + theme.spacing(2) * 2)]: {
            width: 1024,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    headerContainer: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(3),
    },
    footerContainer: {
        paddingTop: theme.spacing(2),
    },
    link: {
        color: theme.palette.text.disabled,
        textDecoration: 'none',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));
